import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-company-detail-modal',
  templateUrl: './company-detail-modal.component.html',
  styleUrls: ['./company-detail-modal.component.css']
})
export class CompanyDetailModalComponent implements OnInit{

  @Input() companyDetail:any;
  @Output() closeModal = new EventEmitter<any>();
  constructor(){}

  ngOnInit(): void {
    console.log('companyDetail', this.companyDetail);
  }


  onCloseModal(){
    this.closeModal.emit();
    
  }
}
